<script>
import {config} from "@/config";
import {createNamespacedHelpers} from "vuex";
const { mapGetters } = createNamespacedHelpers('ai')
export default {
  name: "Item",
  props: ['item'],
  data() {
    return {
      isDeleting: false
    }
  },
  methods: {
    getDownloadUrl() {
      return config.apiUrl + '/ai/test/'+this.item.id+'/download';
    },
    getTotalData() {
      var th = this;
      this.$store.dispatch('ai/GET_TOTAL', {
        th: th,
        urlParams: {
          type: 'test-'+this.item.id,
          id: this.item.id
        }
      });
    },
    async deleteItem() {
      let params = {
        id: this.item.id,
        th: this
      };
      this.isDeleting = true;
      await this.$store.dispatch('ai/DELETE_ITEM', params);
      this.isDeleting = false;
    },
  },
  computed: {
    ...mapGetters([
      'getLocalTotalDataById',
    ]),
    totalData() {
      return this.getLocalTotalDataById(this.item.id)
    }
  }
}
</script>

<template>
  <b-container fluid>
      <b-row class="mb-2">
        <b-col cols="10">
          <b-button
            block href="#"
            v-b-toggle="'accordion-'+ item.id"
            :variant="item.processed<item.total ? 'primary' : 'success'"
          >
            {{ item.id }} - {{ item.title }} - {{ item.createdAt}}
          </b-button>
        </b-col>
        <b-col cols="2">
          <b-button
            block
            variant="danger"
            v-on:click="deleteItem"
            :disabled="isDeleting"
          >
            <span class="waiting-state" v-if="!isDeleting">Удалить</span>
            <section class="process-state" v-if="isDeleting">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Удаление ...
            </section>
          </b-button>
        </b-col>
      </b-row>
    <b-collapse :id="'accordion-'+ item.id" accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <b-container fluid>
          <b-row>
            <b-col class="text-align-left col-4">
              <b-card-text>Total items: {{ totalData.total }}</b-card-text>
              <b-card-text class="pb-4">Processed: {{ totalData.processed }}
                ({{ totalData.total == 0 ? 0 : Math.round(totalData.processed / totalData.total * 100) }}%)
              </b-card-text>
              <a :href="getDownloadUrl(item.id)">Download</a>
              <b-button class="ml-2" size="sm" variant="primary" @click="getTotalData">Refresh</b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-card-body>
    </b-collapse>
  </b-container>
</template>

<style scoped>

</style>